module.exports = __webpack_public_path__ + "img/3W.be582bf0.png";